<template>
  <div class="m-yunxiao parent ask-time-off">
    <van-form class="main" ref="form" input-align="right">
      <van-field v-model="formData.studentName"
        label="请假学员" 
        required
        placeholder="请选择" 
        :right-icon="'arrow'" 
        readonly
        @click="studentPickerShow = true"
        name="name" />
      <van-cell title="请假课次" is-link required @click="selectArrange" :border="false">
        <template>
          <div v-if="arrange && arrange.id" style="color: var(--g8);">
            重新选择
          </div>
          <div v-else style="color: var(--g5)">请选择</div>
        </template>
      </van-cell>
      <div class="arrange-infos-wrapper" v-if="arrange && arrange.id">
        <div class="arrange-infos" >
          <p>
            {{ arrange.className || '' }}
            {{ arrange.startTime | formatDatetime('MM月dd日') }}({{
              arrange.startTime | getWeek
            }}) {{ arrange.startTime | formatDatetime('hh:mm') }}～{{
              arrange.endTime | formatDatetime('hh:mm')
            }}
          </p>
          <p>
            {{ arrange.curriculumName }}
          </p>
          <p>
            {{ arrange.campusName }}
          </p>

        </div>
      </div>
      <div class="block">

        <div class="notes-til">
          请假原因
        </div>
        <van-field
          class="txa"
          type="textarea"
          v-model="formData.reason"
          autosize
          rows="2"
          maxlength="200"
          placeholder="请输入请假原因"
          show-word-limit
          input-align="left"
        />
      </div>
      <div class="desc" v-if="rule.leaveMaxTimes">
        <template v-if="rule.leaveTimePeriod === 0">          
          温馨提醒：每个学员每个课程最多可请假{{rule.leaveMaxTimes}}次
        </template>
        <template v-else-if="rule.leaveTimePeriod === 3">
          温馨提醒：{{rule.leaveLimitStartTime}} 至 {{rule.leaveLimitEndTime}}期间每个学员每个课程最多可请假{{rule.leaveMaxTimes}}次
        </template>
        <template v-else>          
          温馨提醒：每个学员每个课程{{rule.leaveTimePeriod === 1 ? '每月': '每周'}}最多可请假{{rule.leaveMaxTimes}}次
        </template>

      </div>
    </van-form>
    <div class="footer">
      <van-button 
        block 
        square round 
        type="primary" 
        :loading="submiting" 
        loading-text="提交中..." 
        @click="saveHandler">
        提交申请
      </van-button>
    </div>
    <van-popup 
      :value="studentPickerShow" 
      position="bottom" 
      @click-overlay="studentPickerShow = false">
      <van-picker
        :show-toolbar="true"
        title="选择学员"
        :value-key="'name'"
        :columns="studentList"
        @confirm="studentPickerConfirm"
        :default-index="defaultIndex"
        @cancel="studentPickerShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'askTimeOff',
  data () {
    return {
      pageTitle: '申请请假',
      submiting: false,
      formData: {
        studentName: '',
        studentId: '',
        reason: '',
      },
      studentPickerShow: false,
      studentList: [],
      choosedStudent: '',
      defaultIndex: -1,
      arrange: {},
      rule: {},
    }
  },
  methods: {
    saveHandler () {
      let courseArrangeId = this.arrange.id;
      if (!courseArrangeId) {
        this.$toast('请选择要请假的课次');
        return false;
      }
      this.showLoading();
      let { studentId, reason } = this.formData;
      this.$api.leaveStudent({
        studentId, 
        reason,
        courseArrangeId,
      })
        .then(res=> {
          if (res.code === 200) {
            this.$toast.success('提交成功');
            this.$router.back();
            app.vue.$emit('refresh-timeoff-list');
          } else if (res.code === 830000036) {
            const {leaveRule} = res.data;
            let unit = ['', '每月', '每周', `${leaveRule.leaveLimitStartTime}至${leaveRule.leaveLimitEndTime}期间`][leaveRule.leaveTimePeriod]
            let unit2 = ['', '本月', '本周', ''][leaveRule.leaveTimePeriod]
            vant.Dialog.alert({
              message: `机构设置“每个学员每个课程${unit}最多可请假${leaveRule.leaveMaxTimes}次”，您${unit2}已提交${res.data.alreadyLeaveTimes}次请假，无法继续提交，如有疑问请联系机构老师。`,
              confirmButtonText: '我知道了',
              showCancelButton: false,
            })
          } else if (res.code > 60000) {
            app.http.tipErr(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err=>{
          console.log(err)
        })
    },
    selectArrange () {
      let { studentId } = this.formData;
      if (!studentId) {
        this.$toast('请选择要请假的学员');
        return false;
      }
      app.x3.side
        .xsCoureseArrange({
          id: this.arrange ? this.arrange.id : '',
          api: this.$api.getCourse,
          params: {
            studentId,
          },
          config: {
            enableFilter: false,
            enableSearch: false,
            must: true,
          }
        })
        .then(res => {
          this.arrange = res;
        });
    },
    studentPickerConfirm(e,idx) {
      this.studentPickerShow = false;
      if (this.formData.studentId !== e.id) {
        this.arrange = {};
      }
      ({id: this.formData.studentId, name: this.formData.studentName} = e);
      this.defaultIndex = idx;
    }
  },
  async created () {
    this.showLoading();
    let getStudentList = this.$api.parentGetStudentList()
    let promiseArr = [getStudentList]
    getStudentList.then((res) => {
      this.studentList = res.data;
      if (res.code > 60000) {
        app.http.tipErr(res.msg || '网络异常，请稍后重试');
      }
    });
   
    // 如果带id，表示从请假详情发起的重新申请 
    if (this.$vxRoute.query && this.$vxRoute.query.id) {
      let getLeaveStudent =   this.$api.getLeaveStudent({
        leaveId: this.$vxRoute.query.id,
      })      
      promiseArr.push(getLeaveStudent);

      getLeaveStudent.then(res=> {
          if (res.code === 200) {
            this.formData.studentName = res.data && res.data.student && res.data.student.name;
            this.formData.studentId = res.data && res.data.student && res.data.student.studentId;
            this.formData.reason = res.data && res.data.reason;
            this.arrange = res.data.courseArrange;
            this.arrange.id = res.data.courseArrangeId;
          }
          if (res.code > 60000) {
            app.http.tipErr(res.msg || '网络异常，请稍后重试');
          }
        })
    }

    this.$api.getCompanyRule().then(res=>{
      this.rule = res.data;
    });

    try {
      await Promise.all(promiseArr);
      this.$toast.clear();
    } catch(err) {
      console.log(err);
    }
    

  }
}
</script>

<style lang="scss" scoped>
.m-yunxiao.parent.ask-time-off{
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .main {
    flex: 1;
    overflow-y: auto;
    .arrange-infos-wrapper{
      overflow: hidden;
      background-color: var(--white);
    }
    .arrange-infos{
      padding: calc(var(--gap) * 16);
      margin: 0 calc(var(--gap) * 16) calc(var(--gap) * 16);
      border-radius: var(--radius-sm);
      color: var(--g7);
      border: 1px solid var(--g3);
      >p{
        margin: 0;
      }
      >p:not(:last-child){
        margin: 0 0 calc(var(--gap) * 8);
      }
    }
    .block {
      margin: calc(var(--gap) * 12) 0;
    }
    ::v-deep .van-cell__title,
    ::v-deep .van-field__label {
      color: var(--g7);
      flex: unset;
      width: calc(var(--w) * 80);
    }
    .notes-til {
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16) 0;
      background: var(--white);
    }
    .txa {
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
      ::v-deep .van-field__word-limit {
        color: var(--g6);
      }
    }
  }
  .desc {
    color: var(--g6);
    padding: 12px 16px;
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
  .footer {
    background-color: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    ::v-deep .van-button {
      height: calc(var(--w) * 40);
    }

  }
}
</style>